export default {
  DREAMER: 'Dreamer',
  FOUNDER: 'Founder',
  TEAM: 'Team',
  TEAM_PRO: 'TeamPro'
}
